import { render, staticRenderFns } from "./SharingDetailsTab.vue?vue&type=template&id=2e6e5b6e&scoped=true"
import script from "./SharingDetailsTab.vue?vue&type=script&lang=js"
export * from "./SharingDetailsTab.vue?vue&type=script&lang=js"
import style0 from "./SharingDetailsTab.vue?vue&type=style&index=0&id=2e6e5b6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6e5b6e",
  null
  
)

export default component.exports